/**
 * @generated SignedSource<<276e1efc3f53ebe73f592240ab43b236>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateReportShareInput = {
  reportId: string;
  emails?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createReportShareMutation$variables = {
  input: CreateReportShareInput;
};
export type createReportShareMutation$data = {
  readonly createReportShare: {
    readonly shareEdges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly user: {
          readonly id: string;
          readonly email: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly warnings: ReadonlyArray<string | null> | null;
  } | null;
};
export type createReportShareMutation = {
  variables: createReportShareMutation$variables;
  response: createReportShareMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateReportSharePayload",
    "kind": "LinkedField",
    "name": "createReportShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportShareTypeEdge",
        "kind": "LinkedField",
        "name": "shareEdges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportShare",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReportShareUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "warnings",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createReportShareMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createReportShareMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "251cde35d9543aef438bcb9f8ee21c98",
    "id": null,
    "metadata": {},
    "name": "createReportShareMutation",
    "operationKind": "mutation",
    "text": "mutation createReportShareMutation(\n  $input: CreateReportShareInput!\n) {\n  createReportShare(input: $input) {\n    shareEdges {\n      node {\n        id\n        user {\n          id\n          email\n        }\n      }\n    }\n    warnings\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8f858e7fb623ff34e4c1d3d8f06c9f1";

export default node;
